/* eslint-disable import/prefer-default-export */

export const selectableCompanies = (currentUserCompany, selectedCompany) =>
  currentUserCompany.children
    .concat(currentUserCompany)
    .filter((selectableCompany) => selectableCompany.id !== selectedCompany.id)
    .map((selectableCompany) => ({
      id: selectableCompany.id,
      name: selectableCompany.name,
    }));
